import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TableLayoutGeneratorForm.html?raw';
import on from 'dojo/on';
import Selectbox from '../SelectBox/SelectBox';
import "../SelectBox/SelectBox";
import Button from '../Button/Button';
import "../Button/Button";
import Edit from '../Edit/Edit';
import "../Edit/Edit";
import NumberInput from '../NumberInput/NumberInput';
import "../NumberInput/NumberInput";
import StaticTable from '../StaticTable/StaticTable';
import "../StaticTable/StaticTable";
import { stringify } from "dojo/json";


class TableLayoutGeneratorForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    layoutRows: any = [];
    layoutFields: any = [];
    layoutFieldObject: any = {};
    rowSelector: MdsLax<InstanceType<typeof Selectbox>>;
    selectBoxContainer: HTMLDivElement;
    selectionValue: SelectionValueEntity = null;
    _data_SelectionValues: Array<SelectionValueEntity>;
    btnAddRow: MdsLax<InstanceType<typeof Button>>;
    btnAddField: MdsLax<InstanceType<typeof Button>>;
    btnRemoveRow: MdsLax<InstanceType<typeof Button>>;
    btnRemoveField: MdsLax<InstanceType<typeof Button>>;
    btnAddFieldToRow: MdsLax<InstanceType<typeof Button>>;
    btnCreateJson: MdsLax<InstanceType<typeof Button>>;
    btnCreateForm: MdsLax<InstanceType<typeof Button>>;
    fieldContainer: HTMLDivElement;
    showOutput: HTMLDivElement;
    outputTable: MdsLax<InstanceType<typeof StaticTable>>;


    pos: MdsLax<InstanceType<typeof NumberInput>>;
    attribute: MdsLax<InstanceType<typeof Edit>>;
    bgColor;
    colNameInternal: MdsLax<InstanceType<typeof Edit>>;
    colspan: MdsLax<InstanceType<typeof NumberInput>>;
    heading: MdsLax<InstanceType<typeof Edit>>;
    txtColor;
    width: MdsLax<InstanceType<typeof Edit>>;
    headingColorsBG;
    headingColorsTXT;
    alignmentsHeading: MdsLax<InstanceType<typeof Edit>>;
    alignmentsRow: MdsLax<InstanceType<typeof Edit>>;
    output: MdsLax<InstanceType<typeof Edit>>;

    lastId = 0;
    currentRow = "1";

    createJson() {
        this._getValuesFromInput();

        let json = [];

        this.layoutRows.forEach(lang.hitch(this, function (row) {
            let obj = {};

            row.fields.forEach(lang.hitch(this, function (field) {
                Object.keys(field).forEach(lang.hitch(this, function (key) {
                    if (key != "ID" && key != "pos") {
                        if (!obj[key]) {
                            obj[key] = []
                        }
                        if (field[key] == "#000000") {
                            field[key] = null;
                        }
                        obj[key].push(field[key])
                    }
                }))
            }))
            json.push(obj);
        }))
        this._createOutputTable(json);
        this.output.setValue(stringify(json));
    }

    createForm() {
        this.layoutRows = [];

        let json = JSON.parse(this.output.getValue());
        let rows = [];
        let rowIndex = 1;

        json.forEach(lang.hitch(this, function (rowConfig) {
            let fields = [];
            Object.keys(rowConfig).forEach(lang.hitch(this, function (key) {
                let index = 0;
                rowConfig[key].forEach(lang.hitch(this, function (fieldValue) {
                    if (!fields[index]) {
                        fields[index] = {}
                        fields[index]["ID"] = index;
                    }
                    fields[index][key] = fieldValue;
                    index++;
                }))
            }))
            rows.push({ "row": rowIndex, "fields": fields });
            rowIndex++;
        }))

        this.layoutRows = rows;
        this._createOutputTable(json);

        this.rowSelector.clear();

        rows.forEach(lang.hitch(this, function (row) {
            this.rowSelector.addEntry(row["row"].toString(), "RowConfig " + row["row"])
        }))

        this.rowSelector.constructOptions();
        this.rowSelector.setValue(rows[0]["row"].toString());
        this.layoutFields = rows[0]["fields"];
        this.layoutFieldObject = this.layoutFields[0];
        this._setValues()
    }

    _createOutputTable(configs) {
        if (this.outputTable) {
            this.outputTable.destroy();
        }
        this.outputTable = new StaticTable();
        let data = {};

        this.layoutRows.forEach(lang.hitch(this, function (row) {
            let index = 1;
            row.fields.forEach(lang.hitch(this, function (field) {
                data[field.attributes] = "Wert " + index;
                index++
            }))
        }));
        configs.forEach(lang.hitch(this, function (config) {
            this.outputTable.addLineConfig(config)
        }))
        this.outputTable.setData([data]);
        this.UiModder.domConstruct.place(this.outputTable.domNode, this.showOutput, "last");
    }

    _addNewField() {
        this.lastId++;
        this.layoutFieldObject = {
            "ID": this.lastId ,
            //"pos": this.layoutFields.length + 1,
            "attributes": "",
            "colNamesInternal": "",
            "colspans": 1,
            "headings": "new Field",
            "widths": "",
            "bgColors": null,
            "txtColors": null,
            "headingColorsBG": null,
            "headingColorsTXT": null,
            "alignmentsHeading": "",
            "alignmentsRow": ""
        };
        this.layoutFields.push(this.layoutFieldObject);
        //this.layoutRows["fields"] = this.layoutFields;
        this._redrawFieldContainer();
        this._setValues();

    }

    _onAddRowClick() {
        this.lastId = 0;

        let obj = { "row": this.layoutRows.length + 1, "fields": [] }

        this.layoutRows.push(obj);

        this.rowSelector.addEntry(obj["row"].toString(), "RowConfig " + obj["row"])
        this.rowSelector.constructOptions();
        this.rowSelector.setValue(obj["row"].toString())
    }

    _onRemoveRowClick() {
        let index = 1;
        if (this.layoutRows.length == 1) { alert("Letzte Zeile kann nicht gelöscht werden"); return; }

        this.rowSelector.clear();

        this.layoutRows = this.layoutRows.filter(lang.hitch(this, function (data) {
            if (data.row != this.currentRow) {
                data.row = index.toString();
                index++;
                return data
            }
        }));
        this.currentRow = "0";
        this._processSelectionValues(this.layoutRows);
        this._onChange_Select();
    }

    _onAddFieldClick() {
        this._getValuesFromInput();
        this._addNewField();
    }

    _onRemoveFieldClick() {
        this.layoutFields = this.layoutFields.filter(lang.hitch(this, function (field) {
            return field["ID"] != this.layoutFieldObject["ID"];
        }));

        if (this.layoutFields.length > 0) {
            this.layoutFieldObject = this.layoutFields[0]
            this._setValues();
        } else {
            this._addNewField();
        }
        this._redrawFieldContainer();
    }

    _onChange_Select() {
        this._getValuesFromInput();
        this.currentRow = this.rowSelector.getValue();

        this.layoutRows.filter(lang.hitch(this, function (row) {
            if (row.row == this.currentRow) {
                this.layoutFields = row.fields
            }
        }))

        this.lastId = this.layoutFields.length;
        if (this.layoutFields.length > 0) {
            this.layoutFieldObject = this.layoutFields[0]
            this._setValues();
        } else {
            this._addNewField();
        }
        this._redrawFieldContainer();
    }

    _getValuesFromInput() {

        //this.layoutFieldObject["pos"] = this.pos.getValue();
        this.layoutFieldObject["attributes"] = this.attribute.getValue();
        this.layoutFieldObject["colNamesInternal"] = this.colNameInternal.getValue();
        this.layoutFieldObject["colspans"] = this.colspan.getValue();
        this.layoutFieldObject["headings"] = this.heading.getValue();
        this.layoutFieldObject["widths"] = this.width.getValue();
        this.layoutFieldObject["bgColors"] = this.bgColor.value;
        this.layoutFieldObject["txtColors"] = this.txtColor.value;
        this.layoutFieldObject["alignmentsHeading"] = this.alignmentsHeading.getValue();
        this.layoutFieldObject["alignmentsRow"] = this.alignmentsRow.getValue();
        this.layoutFieldObject["headingColorsTXT"] = this.headingColorsTXT.value;
        this.layoutFieldObject["headingColorsBG"] = this.headingColorsBG.value;


        this.layoutFields.filter(lang.hitch(this, function (data) {
            if (data["ID"] == this.layoutFieldObject["ID"]) {
                data = this.layoutFieldObject;
            }
        }))

        this.layoutRows.filter(lang.hitch(this, function (row) {
            if (row.row == this.currentRow) {
                row["fields"] = this.layoutFields
            }
        }))
    }

    _redrawFieldContainer() {
        this.UiModder.domConstruct.empty(this.fieldContainer);
        //this.layoutFields = this.layoutFields.sort(function (a, b) { return a.ID - b.ID })

        this.layoutFields.forEach(lang.hitch(this, function (row) {
            let btn = new Button();
            btn.setLabel(row.headings);
            this.UiModder.domStyle.set(btn.domNode, "float", "left");


            btn.setClasses("mds-gray mds-hover-bright w3-margin-right w3-margin-top");
            if (row.ID == this.layoutFieldObject["ID"]) {
                btn.setClasses("mds-blue")
            }

            btn.placeAt(this.fieldContainer)
            btn._onClick_Button = lang.hitch(this, this._selectField, row);
        }))

        this.btnAddField = new Button();
        this.btnAddField.setLabel("Feld hinzufügen");
        this.btnAddField.setClasses("accentBG mds-hover-bright w3-margin-top");
        this.btnAddField.setIconLeft("fas fa-plus");
        this.btnAddField._onClick_Button = lang.hitch(this, this._onAddFieldClick);
        this.UiModder.domStyle.set(this.btnAddField.domNode, "float", "left");
        this.btnAddField.placeAt(this.fieldContainer, "last")
    }

    _selectField(row) {
        this._getValuesFromInput();
        this.layoutFieldObject = row;
        this._redrawFieldContainer();
        this._setValues();
    }

    _processSelectionValues(items) {

        this._data_SelectionValues = items;

        for (let entity of this._data_SelectionValues) {
            this.rowSelector.addOption(entity["row"].toString(), "RowConfig " + entity["row"], true);
        }

        this.rowSelector.startup();

    }

    _setValues() {
        //this.pos.setValue(this.layoutFieldObject["pos"]);
        this.attribute.setValue(this.layoutFieldObject["attributes"]);
        this.colNameInternal.setValue(this.layoutFieldObject["colNamesInternal"]);
        this.colspan.setValue(this.layoutFieldObject["colspans"]);
        this.heading.setValue(this.layoutFieldObject["headings"]);
        this.width.setValue(this.layoutFieldObject["widths"]);
        this.bgColor.value = this.layoutFieldObject["bgColors"];
        this.txtColor.value = this.layoutFieldObject["txtColors"];
        this.alignmentsHeading.setValue(this.layoutFieldObject["alignmentsHeading"]);
        this.alignmentsRow.setValue(this.layoutFieldObject["alignmentsRow"]);
        this.headingColorsTXT.value = this.layoutFieldObject["headingColorsTXT"];
        this.headingColorsBG.value = this.layoutFieldObject["headingColorsBG"];
    }

    _setButtons() {
        this.btnAddRow.setLabel("Zeile hinzufügen");
        this.btnAddRow.setIconLeft("fas fa-plus");
        this.btnAddRow.setClasses("accentBG mds-hover-bright");

        this.btnRemoveRow.setLabel("Zeile entfernen");
        this.btnRemoveRow.setIconLeft("fas fa-trash warningTXT");
        this.btnRemoveRow.setClasses("mds-orange mds-hover-bright");

        this.btnRemoveField.setLabel("Feld entfernen");
        this.btnRemoveField.setIconLeft("fas fa-trash warningTXT");
        this.btnRemoveField.setClasses("mds-orange mds-hover-bright");

        this.btnCreateJson.setLabel("generate Json");
        this.btnCreateJson.setIconLeft("fas fa-redo");
        this.btnCreateJson.setClasses("accentBG mds-hover-bright");

        this.btnCreateForm.setLabel("import Json");
        this.btnCreateForm.setIconLeft("fas fa-redo");
        this.btnCreateForm.setClasses("accentBG mds-hover-bright");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.rowSelector = new Selectbox();
        this.rowSelector.placeAt(this.selectBoxContainer);

        this.layoutRows.push({ "row": 1, "fields": [] });
        this.output.setIsMultiline(true);

        this._addNewField()
        this._setValues();
        this._setButtons();
        this.createJson();

        this._processSelectionValues(this.layoutRows);
        on(this.rowSelector, "change", lang.hitch(this, this._onChange_Select));

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TableLayoutGeneratorForm);
